import { Flex, Heading, Text } from "@instructure/ui";
import { useTranslation } from "react-i18next";
import "../../../CustomTextArea/rte.css";

const EmbeddedDashboardPreview = ({ measure, key1, key2 }) => {
  const { t } = useTranslation();

  return (
    <Flex direction="column">
      <Flex.Item>
        <Heading level="h3">
          {`${measure.name ?? t("embeddedDashboard.embeddedDashboard")}`}
        </Heading>
      </Flex.Item>
      <Flex.Item margin="small 0 medium large">
        <Text>{measure.description}</Text>
      </Flex.Item>
      <Flex.Item overflowX="hidden" padding="0 0 0 large">
        <div
          id={`preview-measure-${key1}-${key2}`}
          style={{
            height: 240,
            border: "1px solid #ccc",
            backgroundColor: "#f0f0f0",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text size="xx-large">{t("embeddedDashboard.goesHere")}</Text>
        </div>
      </Flex.Item>
    </Flex>
  );
};

export default EmbeddedDashboardPreview;
